import * as Yup from 'yup'
import {
  emptySpacesMessage,
  mandatoryFieldMessage,
  mandatoryNumberFieldMessage,
} from './messagesContants'
import { emptySpaceCharsAtStartAndEndRegex } from './constants'
export const hexOrRgbColorValidationNotRequired = Yup.string()
  .test(
    'is-hex-or-rgba',
    'Please provide a valid HEX or RGBA color.',
    value => {
      if (!value) return true
      if (value.startsWith('rgba')) return true
      return /^#[0-9A-F]{6}$|^#[0-9A-F]{8}$/i.test(value)
    }
  )
  .notRequired()

const TemplateDesignFormFormikValidationSchema = Yup.object().shape({
  data: Yup.object().shape({
    name: Yup.string().required('Template name cannot be empty'),
    productTitle: Yup.object().shape({
      customization: Yup.object().shape({
        fontSize: Yup.string().required('Font size cannot be empty'),
        fontWeight: Yup.string().required('Font weight cannot be empty'),
        color: hexOrRgbColorValidationNotRequired,
      }),
    }),
    card: Yup.object().shape({
      customization: Yup.object().shape({
        backgroundColor: hexOrRgbColorValidationNotRequired,
        borderColor: hexOrRgbColorValidationNotRequired,
        font: Yup.string().required('Font cannot be empty'),
        borderRadius: Yup.string().required('Border radius cannot be empty'),
        borderStrokeWidth: Yup.string().required(
          'Border stroke width cannot be empty'
        ),
      }),
    }),
    cardContent: Yup.object().shape({
      customization: Yup.object().shape({
        color: hexOrRgbColorValidationNotRequired,
        fontSize: Yup.string().required('Font size cannot be empty'),
        fontWeight: Yup.string().required('Font weight cannot be empty'),
      }),
    }),
    privateOfferForm: Yup.object().shape({
      fieldsToDisplay: Yup.array().of(
        Yup.object().shape({
          displayName: Yup.string()
            .required(mandatoryFieldMessage)
            .max(72, 'Max 72 characters are allowed')
            .matches(
              emptySpaceCharsAtStartAndEndRegex,
              `${emptySpacesMessage}.`
            ),
          dataType: Yup.string().required(mandatoryFieldMessage),
          isRequired: Yup.boolean().required(mandatoryFieldMessage),
          validationType: Yup.string().nullable(),
          minLength: Yup.number()
            .typeError('Minimum character length must be a valid number')
            .min(0, 'Not negative number')
            .when('maxLength', (maxLength, schema) =>
              schema.test({
                test: (minLength: number) => minLength <= maxLength,
                message:
                  'Minimum length must be smaller than or equal to the maximum length',
              })
            )
            .required(mandatoryNumberFieldMessage)
            .when('isRequired', (isRequired, schema) =>
              schema.test({
                test: (minLength: number) =>
                  isRequired ? Number(minLength) > 0 : minLength >= 0,
                message:
                  'Minimum length must be greater than 0 if it is required',
              })
            ),
          maxLength: Yup.number()
            .typeError('Maximum character length must be a valid number')
            .min(0, 'Not negative number')
            .required(mandatoryNumberFieldMessage),
        })
      ),
    }),
    requestDemoForm: Yup.object().shape({
      fieldsToDisplay: Yup.array().of(
        Yup.object().shape({
          displayName: Yup.string()
            .required(mandatoryFieldMessage)
            .max(72, 'Max 72 characters are allowed')
            .matches(
              emptySpaceCharsAtStartAndEndRegex,
              `${emptySpacesMessage}.`
            ),
          dataType: Yup.string().required(mandatoryFieldMessage),
          isRequired: Yup.boolean().required(mandatoryFieldMessage),
          validationType: Yup.string().nullable(),
          minLength: Yup.number()
            .typeError('Minimum character length must be a valid number')
            .min(0, 'Not negative number')
            .when('maxLength', (maxLength, schema) =>
              schema.test({
                test: (minLength: number) => minLength <= maxLength,
                message:
                  'Minimum length must be smaller than or equal to the maximum length',
              })
            )
            .required(mandatoryNumberFieldMessage)
            .when('isRequired', (isRequired, schema) =>
              schema.test({
                test: (minLength: number) =>
                  isRequired ? Number(minLength) > 0 : minLength >= 0,
                message:
                  'Minimum length must be greater than 0 if it is required',
              })
            ),
          maxLength: Yup.number()
            .typeError('Maximum character length must be a valid number')
            .min(0, 'Not negative number')
            .required(mandatoryNumberFieldMessage),
        })
      ),
    }),
    filledButton: Yup.object().shape({
      color: hexOrRgbColorValidationNotRequired,
      backgroundColor: hexOrRgbColorValidationNotRequired,
    }),
    outlinedButton: Yup.object().shape({
      color: hexOrRgbColorValidationNotRequired,
      borderColor: hexOrRgbColorValidationNotRequired,
    }),
  }),
})

export default TemplateDesignFormFormikValidationSchema
